import React from 'react';
import './SearchContainer.scss';

const SearchContainer = ({ children }) => {
  return <div className="search-container">{children}</div>;
};

export default SearchContainer;
